<template>
  <!-- select/radio/checkbox/groupselect 本地静态选项类：mode（仅 select）+ show_search；
       ★ v29.29：选项列表（数值/显示文本）在「数据源」页维护——选项统一为 `{value, label}`
       （lybase ADVANCED_SEARCH + choices 契约），故不再暴露 valueKey/labelKey
       （残留 labelKey:'name' 会让选项渲染成空白，详见 constants.ts 说明）。 -->
  <a-row :gutter="16">
    <SelectionModeConfig
      v-if="MODE_TYPES.includes(config.type)"
      :config="config"
      field="mode"
    />
    <ShowSearchConfig :config="config" />
    <a-col :span="24">
      <div class="flat-hint">
        本地静态选项（数值 / 显示文本）在「数据源」页的「选项列表」中维护；选项对象为
        <code>{ value, label }</code>。
      </div>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
import { MODE_TYPES } from '../constants';
import SelectionModeConfig from '../SelectionModeConfig.vue';
import ShowSearchConfig from '../ShowSearchConfig.vue';

defineProps<{ config: any }>();
</script>

<style scoped lang="less">
.flat-hint {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.5;
  margin-top: 4px;
}
</style>
